<!-- 系统管理-菜单管理 -->
<template>
  <div v-if="!show_detail">
    <!-- 卡片 -->
    <div class="md-layout" style="flex-wrap: nowrap;">
      <!-- 左侧-部门选择 -->
      <div class="md-layout-item" style="max-width: 280px; min-width: 240px; padding-left: 0;padding-right: 0;">
        <md-card>
          <!-- 卡片-主体 -->
          <md-card-content>
            <!-- 筛选-Input -->
            <div style="position: relative;">
              <common-form-item 
                style="margin-bottom: 16px;"
                :labelweight="100"
                v-model="tree_filter" 
                type="input"
                placeholder="test-filter"
              />
              <md-icon class="search-icon">search</md-icon>
            </div>
            <!-- 部门 -->
              <!-- :data="orgZoneData" -->
            <tree
              ref="tree"
              node-key="_id"
              
              :props="treeDefaultProps"
              lazy
              :load="getZone"
              @node-collapse="closeExpd"
              @node-expand="openExpd"
              :default-expanded-keys="defaultExpd"
              :filter-node-method="filterNode"
            >
              <div class="custom-tree-node diy-tree-node" slot-scope="{ data }" :class="{
                'selected-tree': tree_sel_id === data._id,
              }" @click="(event) => changeTree(data, event)">
                <span 
                  v-if="data._lazy || (data.children && data.children.length > 0)"
                  :ref="'tree_'+data._id"
                  @click="(event) => expandedTree(data, event)"
                  class="el-tree-node__expand-icon el-icon-caret-right" 
                  :class="{'expanded': defaultExpd.includes(data._id)}"
                ></span>
                <span class="diy-tree-title">{{ data.name }}</span>
              </div>
            </tree>
          </md-card-content>
        </md-card>
      </div>
      <!-- 右侧-主要表格 -->
      <div class="md-layout-item">
        <md-card>
          <!-- 卡片-主体 -->
          <md-card-content>
            <!-- 顶部-表单+按钮 -->
            <div style="margin-bottom: 12px;">
              <div class="table-form-box">
                <!-- 姓名/工号/手机号 -->
                <div style="display: inline-block;width: 330px; margin-right: 25px;">
                  <common-form-item 
                    v-model="tree_filter" 
                    type="input"
                    :placeholder="$I18n('pls_enter_devname_num')"
                    :bigBorder="true"
                  />
                </div>
                <div style="display: flex;">
                  <!-- 查询 -->
                  <md-button class="big-button diy-back-blue has-button" @click="goSearch">
                    <md-icon>search</md-icon>
                    {{$I18n("search")}}
                  </md-button>
                  <!-- 重置 -->
                  <md-button class="diy-blue has-button" @click="resetSearch">
                    <md-icon>refresh</md-icon>
                    {{$I18n("reset")}}
                  </md-button>
                </div>
              </div>
              <div class="table-button-box">
                <!-- 添加人员 -->
                <md-button class="diy-blue has-button" @click="table_addDeive">
                  <md-icon>add</md-icon>
                  {{$I18n("add_dev")}}
                </md-button>
                <!-- 导入 -->
                <md-button class="diy-blue has-button">
                  <md-icon>add</md-icon>
                  {{$I18n("import")}}
                </md-button>
              </div>
            </div>
            <!-- 表格 -->
            <md-table class="no-hidden diy-gray" v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
                <!-- 注册照片 -->
                <md-table-cell :md-label="$I18n('equip_name')">{{ item.dev_user }}</md-table-cell>
                <md-table-cell :md-label="$I18n('equip_area')">{{ item.loc_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('mark_num_sn')">{{ item.uid }}</md-table-cell>
                <md-table-cell :md-label="$I18n('dev_state')">{{ item.state_name }}</md-table-cell>

                <md-table-cell :md-label="$I18n('operate')" class="button-cell">
                  <md-button @click="table_detailsDeive(item)" @click.stop class="md-simple md-info">
                    particulars
                  </md-button>
                  <div style="display:inline-block;position: relative;top: -9px;">
                    <drop-down>
                      <div>
                        <md-icon style="font-size: 18px !important;">more_vert</md-icon>
                      </div>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li @click="() => table_editDeive(item)">
                          <a>{{ $I18n("compiler") }}</a>
                        </li>
                        <li @click="() => table_delDeive(item)">
                          <a>{{ $I18n("delete") }}</a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <table-page :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <!--  -->
    <modal-device ref="device" @close="api_getPageData" :organi="sel_organi"/>
  </div>
  <div v-else>
    <md-card style="width: 100%;">
      <!-- 卡片-主体 -->
      <md-card-content>
        <div class="dev-info">
          <h4>{{$I18n("base_info")}}</h4>
          <div class="dev-info-box">
            <div>
              <div class="dev-label">{{$I18n("dev_name")}}</div>
              <div class="dev-span">{{dev_detail.dev_name}}</div>
            </div>
            <div>
              <div class="dev-label">{{$I18n("device_id")}}</div>
              <div class="dev-span">{{dev_detail.dev_id}}</div>
            </div>
            <div>
              <div class="dev-label">{{$I18n("dev_mdl")}}</div>
              <div class="dev-span">{{dev_detail.pk_name}}</div>
            </div>
            <div>
              <div class="dev-label">{{$I18n("fir_ver")}}</div>
              <div class="dev-span">{{dev_detail.ver}}</div>
            </div>
            <div>
              <div class="dev-label">{{$I18n("ver_gen")}}</div>
              <div class="dev-span">{{dev_detail.test}}</div>
            </div>
          </div>
          <div class="dev-info-box">
            <div>
              <div class="dev-label">{{$I18n("mac_add")}}</div>
              <div class="dev-span">{{dev_detail.mac}}</div>
            </div>
            <div style="flex: 4;">
              <div class="dev-label">{{$I18n("rmt_opr")}}</div>
              <div class="dev-span"></div>
            </div>
          </div>
          <div class="dev-bottom">
            <md-button class="diy-back-blue" @click="show_detail = false">
              {{$I18n("back")}}
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { Tree } from 'element-ui';
import ModalDevice from "./ModalDevice.vue";
export default {
  props:["sel_organi"],
  components: {Tree,ModalDevice},
  data() {
    return {
      /* 详情页面 */
      show_detail: false,
      dev_detail: {

      },
      /* 左侧 */
      defaultExpd: [], // 默认展开项目
      tree_sel_id : "",     // 选中部门
      tree_sel_org: this.sel_organi,
      tree_sel_zone:0,
      orgZoneData: [],    // Tree数据 部门数据
      tree_filter: "",
      treeDefaultProps: {  // TREE 默认数据
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },

      /* 右侧 */
      searchForm : {
        like: "",
      },
      searchData  : {
        like: "",
      },
      total       : 1000,
      pageSize    : 10,
      currentPage : 1,
      noRepeat    : false,
      tableData   : [],    // 表格-展示数据
    };
  },
  mounted : function() {
    this.tree_sel_id = "id_org_"+this.sel_organi;
    this.api_getPageData();
  },
  watch: {
    tree_filter(val){
      this.$refs.tree.filter(val);
    },
    tree_sel_id(){
      this.currentPage = 1;
      this.api_getPageData();
      this.noRepeat = true;
    },
    pageSize(){
      this.currentPage = 1;
      this.api_getPageData();
      this.noRepeat = true;
    },
    currentPage(){
      this.api_getPageData();
    },
  },
  computed: {

  },
  methods: {
    table_addDeive(){
      this.$refs.device.open("add");
    },
    table_detailsDeive(data){
      this.$api.g_DevInfo({
        uid: data.uid,
      }).then(res => {
        this.dev_detail = {
          ...data,
          ...res.data,
        }
      })
      .catch(this.$Catch(this.$I18n("get_error")))
      this.show_detail = true;
    },
    table_editDeive(data){
      this.$refs.device.open("edit", data);
    },
    table_delDeive(data){
      this.$refs.device.open("del", data);
    },
    // TREE 逻辑相关 
      closeExpd(item){
        this.defaultExpd = this.defaultExpd.filter(i => i !== item._id)
      },
      openExpd(item){
        this.defaultExpd = [...this.defaultExpd, item._id]

      },
      // 点击 树状图 展开
      expandedTree(data, event){
        this.$refs["tree_"+ data._id].parentNode.previousElementSibling.click();
        event.stopPropagation();
      },
      // 点击 树状图 切换
      changeTree(data, event){
        this.tree_sel_org  = data._org_id;
        this.tree_sel_zone = data._zone_id;
        this.tree_sel_id   = data._id;
        event.stopPropagation();
        return false
      },
      // 树状图筛选方法
      filterNode(value, data) {
        if (!value||!data) return true;
        return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      },

      getZone(data, resolve){
        if(data.level === 0){
          return this.$api.g_Organi({
            get_menu:0,
            get_dept:0,
          })
            .then(res => {
              return res.data.map(i => {
                return {
                  ...i,
                  _org_id: i.id,
                  _zone_id: 0,
                  _id: "id_org_"+ i.id,
                  _lazy: true,
                  isLeaf: 'leaf',
                }
              })
            })
            .catch(this.$Catch(this.$I18n("get_error"),() => {
              return []
            }))
            .then(res => {
              resolve(res)
            })
        }
        return this.$api.g_DevZone({
          home_id : data.data._org_id,
          page_no  : 1,
          page_size: 9999,
        })
          .then(this.$Then(res => {
            return res.data.map(i => {
              return {
                ...i,
                _org_id: data.data._org_id,
                _zone_id: i.id,
                _id: "id_zone_"+ i.id,
                isLeaf: true,
              }
            })
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            return []
          }))
          .then(res => {
            resolve(res)
          })
      },

    // 表格相关
      goSearch(){
        this.searchData = {...this.searchForm}
        this.currentPage = 1;
        this.api_getPageData();
        this.noRepeat = true;
      },
      resetSearch(){
        this.searchForm = {
          like: "",
        }
      },
      api_getPageData(){
        if(this.noRepeat){
          return
        }
        const isHttps = window.location.protocol === "https:";
        // 查询设备
        this.$api.__sendNumApi(231, window.appConfig.umeye_api(isHttps, localStorage.umh_host), {
          page_no   : this.currentPage,
          page_size : this.pageSize,
          home_id   : this.tree_sel_org,
          loc_id    : this.tree_sel_zone,
          parent_node_id: "0",
          sub:2,
        },"", localStorage.acc_token)
          // 请求 202
          .then(res => {
            if(res.h.e !== 200){
              throw res
            }
            if(!res.b.nodes || res.b.nodes.length === 0){
              this.total = 0;
              this.tableData = [];
              return 
            }
            return this.$api.__sendNumApi(235, window.appConfig.umeye_api(isHttps, localStorage.umh_host), {
              custom_flag: window.appConfig.custom_flag,
              devs      : res.b.nodes.map(i => i.uid),
            })
              .then(state_res => {
                if(state_res.h.e !== 200){
                  throw state_res
                }
                this.total = res.b.count;
                this.tableData = res.b.nodes.filter((_,i) => i<10).map(i => {
                  const stateInfo = state_res.b.devs.filter(j => j.dev_id === i.uid)[0];
                  if(!stateInfo){
                    return {
                      ...i,
                      dev_umid  : i.uid,
                      dev_user  : i.user_id,
                      dev_passwd: i.user_pwd,
                      state_id: 2,
                      state_name: this.$I18n("off_line"),
                    }
                  }
                  return {
                    ...i,
                    dev_umid  : i.uid,
                    dev_user  : i.user_id,
                    dev_passwd: i.user_pwd,
                    state_id: stateInfo.state,
                    state_name: stateInfo.state === 1?this.$I18n("on_line") :this.$I18n("off_line"),
                  }
                })
              })
          })
          .catch(res => {
            console.error(res)
          })
          .then(() => {
            this.noRepeat = false;
          })
    },
  },
}
</script>
<style scoped>
  .no-hidden,.no-hidden ::v-deep>div, .no-hidden ::v-deep>div table, .no-hidden ::v-deep>div tbody{
    overflow-x: unset;
  }
  .dev-info{
    position: relative;
    padding-bottom: 80px;
    min-height: calc(100vh - 210px);
  }
  .dev-bottom{
    height: 40px;
    width: 100%;
    display: flex;
    position: absolute;
    bottom: 20px;
  }
  .dev-info h4{
    border-left: 2px solid #36AAEB;
    font-size: 13px;
    color: #333;
    font-weight: 600;
    padding-left: 5px;
    line-height: 32px;
  }
  .dev-info-box{
    display: flex;
    border-bottom: 1px solid #00000010;
    line-height: 32px;
    margin: 5px -20px;
    padding: 0 20px;
  }
  .dev-info-box>div{
    flex:1;
    display: flex;
    font-size: 13px;
  }
  .dev-label{
    width: 140px;
  }
  /*TREE*/
  .diy-tree-node .diy-tree-title{
    margin-left: 4px;
    max-width: calc(100% - 37px);
    position: absolute;
    box-sizing: border-box;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .diy-tree-node{
    background: #FFF;
  }
  .diy-tree-node.selected-tree {
    background: #578EFF;
    color: #FFF;
  }
  .selected-tree .el-tree-node__expand-icon{
    color: #FFF !important;
  }
  /*TREE END*/
  .table-image{
    max-width: 38px;
    max-height: 38px; 
    height: auto; 
    width: auto;
  }
  .custom-tree-node{
    margin-left: -25px;
    height: 30px;
    line-height: 30px;
    padding-left: 6px;
    width: 100%;
  }
  .diy-tree-node .md-icon.md-theme-default.md-icon-font{
    transition: none;
  }
  .selected-tree {
    background: #578EFF;
    color: #FFF;
  }
  .selected-tree .md-icon.md-theme-default.md-icon-font{
    color: #FFF;
  }
  .search-icon{
    font-size: 18px !important; 
    position: absolute;
    right: 4px;
    top: 2px;
    cursor: pointer;
  }
  .table-button-box button{
    margin-right: 25px;
  }
  .table-form-box{
    display:flex;
    align-items:center;
    flex-wrap: wrap;
  }
  .table-form-box button{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .table-form-box button:nth-of-type(1){
    margin-right:25px;
  }
</style>